<template>
  <header>
    <LsSupportHeader
      :label="t('longGrass.longGrassReport.title')"
      test-id="long_grass_header-title"
    />
    <p v-if="completedOn" test-id="long_grass_header-completed_date">{{ serviceCompletedOn }}</p>
  </header>
</template>

<script>
import { themedComponentMixin } from '@/mixins';
import LsSupportHeader from '@/views/Authorized/SupportView/components/LsSupportHeader/LsSupportHeader.vue';
import VueTypes from 'vue-types';
import moment from 'moment';

export default {
  name: 'LgHeaderSection',
  components: { LsSupportHeader },
  mixins: [themedComponentMixin],
  props: {
    completedOn: {
      type: VueTypes.string.required,
      required: false,
    },
  },
  computed: {
    serviceCompletedOn() {
      const completedOn = moment(this.completedOn).format('ddd, MMM Do');
      return this.t('longGrass.longGrassReport.serviceCompletedOn', { completedOn });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  margin: 0 0 2.5rem;
}
</style>
